import React, { useEffect, useState } from 'react'
import { getCandidateLocation, getGeoToken, getGeoHistory, getGeoMessages, postGeoMessage } from '../lib/api'

export default function GeoMapModal({ candidate, onClose }) {
  const [loc, setLoc] = useState(null)
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState('')
  const [sending, setSending] = useState(false)
  const [sendResult, setSendResult] = useState('')
  const [activeTab, setActiveTab] = useState('map')
  const [history, setHistory] = useState([])
  const [historyLoading, setHistoryLoading] = useState(false)
  const [messages, setMessages] = useState([])
  const [messagesLoading, setMessagesLoading] = useState(false)
  const [trackLink, setTrackLink] = useState('')
  const [linkCopied, setLinkCopied] = useState(false)

  useEffect(() => {
    load()
    loadTrackLink()
    const interval = setInterval(load, 30000)
    return () => clearInterval(interval)
  }, [candidate.id])

  async function loadTrackLink() {
    try {
      const data = await getGeoToken(candidate.id)
      if (data?.token) setTrackLink(`https://krasnoebeloeoblako.site/geo/${data.token}`)
    } catch(e) {}
  }

  async function loadHistory() {
    setHistoryLoading(true)
    try {
      const data = await getGeoHistory(candidate.id)
      setHistory(Array.isArray(data) ? data : [])
    } catch(e) { setHistory([]) }
    setHistoryLoading(false)
  }

  async function load() {
    const data = await getCandidateLocation(candidate.id)
    setLoc(data)
    setLoading(false)
  }

  async function loadMessages() {
    setMessagesLoading(true)
    try {
      const data = await getGeoMessages(candidate.id)
      setMessages(Array.isArray(data) ? data : [])
    } catch(e) { setMessages([]) }
    setMessagesLoading(false)
  }

  async function sendPush() {
    if (!message.trim() || !loc?.push_token) return
    setSending(true)
    setSendResult('')
    const text = message.trim()
    try {
      const res = await fetch('https://krasnoebeloeoblako.site/api/send-push', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ to: loc.push_token, title: 'Сообщение от координатора', body: text }),
      })
      const json = await res.json()
      if (json?.data?.status === 'ok') {
        await postGeoMessage(candidate.id, text, 'coordinator')
        setSendResult('Отправлено!')
        setMessage('')
        if (activeTab === 'message') loadMessages()
      } else {
        setSendResult('Ошибка отправки')
      }
    } catch(e) {
      setSendResult('Ошибка: ' + e.message)
    } finally {
      setSending(false)
    }
  }

  function copyLink() {
    if (!trackLink) return
    navigator.clipboard.writeText(trackLink).then(() => {
      setLinkCopied(true)
      setTimeout(() => setLinkCopied(false), 2000)
    })
  }

  const hasLocation = loc?.lat && loc?.lng
  const updatedAt = loc?.updated_at ? new Date(loc.updated_at) : null
  const isRecent = updatedAt && (Date.now() - updatedAt.getTime()) < 10 * 60 * 1000
  const mapsUrl = hasLocation ? `https://maps.google.com/maps?q=${loc.lat},${loc.lng}&z=15` : null
  const yandexUrl = hasLocation ? `https://yandex.ru/maps/?pt=${loc.lng},${loc.lat}&z=15&l=map` : null
  const whatsappUrl = trackLink ? `https://wa.me/?text=${encodeURIComponent(`Открой ссылку и разреши геолокацию: ${trackLink}`)}` : null

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div className="geo-map-modal" style={{ background: 'white', borderRadius: 16, padding: 28, maxWidth: 420, width: '100%', boxShadow: '0 8px 40px rgba(0,0,0,0.18)', maxHeight: '90vh', overflowY: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3 style={{ margin: 0, fontSize: 16 }}>📍 Геолокация — {candidate.name}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#888' }}>✕</button>
        </div>

        {/* Ссылка для кандидата */}
        {trackLink && (
          <div style={{ background: '#f0f7ff', borderRadius: 10, padding: 12, marginBottom: 14, fontSize: 12 }}>
            <div style={{ color: '#555', marginBottom: 6, fontWeight: 500 }}>Ссылка для кандидата:</div>
            <div style={{ display: 'flex', gap: 6 }}>
              <button onClick={copyLink} style={{ flex: 1, padding: '6px 10px', borderRadius: 7, border: '1px solid #c7dff5', background: linkCopied ? '#d4edda' : 'white', fontSize: 11, cursor: 'pointer', color: linkCopied ? '#27500A' : '#185FA5', fontWeight: 500 }}>
                {linkCopied ? '✓ Скопировано' : '📋 Скопировать ссылку'}
              </button>
              {whatsappUrl && (
                <a href={whatsappUrl} target="_blank" rel="noreferrer" style={{ flex: 1, padding: '6px 10px', borderRadius: 7, background: '#25D366', color: 'white', fontSize: 11, textDecoration: 'none', textAlign: 'center', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  WhatsApp
                </a>
              )}
            </div>
          </div>
        )}

        <div className="geo-map-tab-strip" style={{ display: 'flex', gap: 4, marginBottom: 16, background: '#f0f0ee', borderRadius: 8, padding: 3 }}>
          {[{ key: 'map', label: '📍 Карта' }, { key: 'history', label: '🗺 Маршрут' }, { key: 'message', label: '💬 Сообщение' }].map(t => (
            <button key={t.key} onClick={() => { setActiveTab(t.key); if (t.key === 'history') loadHistory(); if (t.key === 'message') loadMessages() }}
              style={{ flex: 1, padding: '6px 0', borderRadius: 6, border: 'none', fontSize: 12, fontWeight: activeTab === t.key ? 600 : 400, background: activeTab === t.key ? 'white' : 'transparent', cursor: 'pointer', color: activeTab === t.key ? '#1a1a1a' : '#888', boxShadow: activeTab === t.key ? '0 1px 3px rgba(0,0,0,.1)' : 'none' }}>
              {t.label}
            </button>
          ))}
        </div>

        {loading && <div style={{ textAlign: 'center', color: '#888', padding: 32 }}>Загрузка...</div>}

        {!loading && hasLocation && activeTab === 'map' && (
          <>
            <div className="geo-map-info" style={{ background: '#f8fafc', borderRadius: 10, padding: 16, marginBottom: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ width: 8, height: 8, borderRadius: '50%', background: isRecent ? '#22c55e' : '#f59e0b', display: 'inline-block' }}></span>
                <span style={{ fontSize: 13, color: isRecent ? '#16a34a' : '#b45309', fontWeight: 500 }}>
                  {isRecent ? 'Актуально' : 'Данные устарели'}
                </span>
              </div>
              <div style={{ fontSize: 13, color: '#555', marginBottom: 4 }}>
                Координаты: <b>{loc.lat.toFixed(5)}, {loc.lng.toFixed(5)}</b>
              </div>
              {loc.accuracy && (
                <div style={{ fontSize: 12, color: '#888' }}>Точность: ~{Math.round(loc.accuracy)} м</div>
              )}
              {updatedAt && (
                <div style={{ fontSize: 12, color: '#aaa', marginTop: 4 }}>
                  Обновлено: {updatedAt.toLocaleDateString()} в {updatedAt.toLocaleTimeString()}
                </div>
              )}
              {loc.battery !== null && loc.battery !== undefined && (
                <div style={{ fontSize: 12, marginTop: 4, color: loc.battery < 20 ? '#ef4444' : '#888' }}>
                  🔋 {loc.battery}%{loc.battery < 20 ? ' — телефон разряжается!' : ''}
                </div>
              )}
            </div>

            <iframe
              title="map"
              src={`https://maps.google.com/maps?q=${loc.lat},${loc.lng}&z=15&output=embed`}
              style={{ width: '100%', height: 220, borderRadius: 10, border: 'none', marginBottom: 16 }}
            />

            <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
              <a href={mapsUrl} target="_blank" rel="noreferrer" style={{ flex: 1, textAlign: 'center', padding: '8px 0', borderRadius: 8, background: '#4285f4', color: 'white', fontSize: 13, textDecoration: 'none', fontWeight: 500 }}>
                Google Maps
              </a>
              <a href={yandexUrl} target="_blank" rel="noreferrer" style={{ flex: 1, textAlign: 'center', padding: '8px 0', borderRadius: 8, background: '#fc3f1d', color: 'white', fontSize: 13, textDecoration: 'none', fontWeight: 500 }}>
                Яндекс Карты
              </a>
            </div>
          </>
        )}

        {!loading && !hasLocation && activeTab === 'map' && (
          <div style={{ textAlign: 'center', padding: 32 }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📵</div>
            <div style={{ color: '#888', fontSize: 14 }}>Геолокация ещё не получена.</div>
            <div style={{ color: '#aaa', fontSize: 12, marginTop: 8 }}>Отправьте кандидату ссылку выше и попросите открыть её.</div>
          </div>
        )}

        {activeTab === 'history' && (
          <div>
            {historyLoading && <div style={{ textAlign: 'center', color: '#888', padding: 24 }}>Загрузка...</div>}
            {!historyLoading && history.length === 0 && (
              <div style={{ textAlign: 'center', color: '#aaa', padding: 24, fontSize: 13 }}>Нет данных за последние 24 часа</div>
            )}
            {!historyLoading && history.length > 0 && (
              <>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 8 }}>
                  {history.length} точек за последние 24 часа
                </div>
                <iframe
                  title="history-map"
                  src={`https://maps.google.com/maps?q=${history[history.length-1].lat},${history[history.length-1].lng}&z=13&output=embed`}
                  style={{ width: '100%', height: 220, borderRadius: 10, border: 'none', marginBottom: 12 }}
                />
                <div style={{ maxHeight: 180, overflowY: 'auto' }}>
                  {[...history].reverse().map((h, i) => (
                    <div key={i} style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, padding: '4px 0', borderBottom: '0.5px solid #f5f5f3', color: '#666' }}>
                      <span>{new Date(h.recorded_at).toLocaleTimeString()}</span>
                      <span>{h.lat.toFixed(4)}, {h.lng.toFixed(4)}</span>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        )}

        {activeTab === 'message' && !loading && (
          <div style={{ paddingTop: 4 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a2332', marginBottom: 8 }}>
              💬 Отправить сообщение на телефон
            </div>
            {!loc?.push_token && (
              <div style={{ fontSize: 12, color: '#aaa', marginBottom: 8 }}>
                Кандидат ещё не открыл приложение — пуш недоступен.
              </div>
            )}
            <div style={{ display: 'flex', gap: 8 }}>
              <input
                value={message}
                onChange={e => setMessage(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && sendPush()}
                placeholder="Введите сообщение..."
                disabled={!loc?.push_token || sending}
                style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid #e0e0e0', fontSize: 13, outline: 'none' }}
              />
              <button
                onClick={sendPush}
                disabled={!loc?.push_token || !message.trim() || sending}
                style={{ padding: '8px 16px', borderRadius: 8, background: loc?.push_token && message.trim() ? '#378ADD' : '#e0e0e0', color: loc?.push_token && message.trim() ? 'white' : '#aaa', border: 'none', fontSize: 13, cursor: loc?.push_token && message.trim() ? 'pointer' : 'default', fontWeight: 500 }}
              >
                {sending ? '...' : 'Отправить'}
              </button>
            </div>
            {sendResult && (
              <div style={{ fontSize: 12, marginTop: 6, color: sendResult === 'Отправлено!' ? '#16a34a' : '#ef4444' }}>
                {sendResult}
              </div>
            )}

            <div style={{ marginTop: 16, borderTop: '1px solid #f0f0f0', paddingTop: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: '#888', marginBottom: 8 }}>История сообщений</div>
              {messagesLoading && <div style={{ fontSize: 12, color: '#aaa' }}>Загрузка...</div>}
              {!messagesLoading && messages.length === 0 && (
                <div style={{ fontSize: 12, color: '#aaa' }}>Сообщений ещё не было</div>
              )}
              {!messagesLoading && messages.map((m, i) => (
                <div key={i} className="geo-map-history-item" style={{ background: '#f8fafc', borderRadius: 8, padding: '8px 10px', marginBottom: 6 }}>
                  <div style={{ fontSize: 13, color: '#1a2332', marginBottom: 4 }}>{m.message}</div>
                  <div style={{ fontSize: 11, color: '#aaa' }}>
                    {new Date(m.sent_at).toLocaleDateString('ru-RU')} в {new Date(m.sent_at).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'map' && (
          <button onClick={load} style={{ marginTop: 12, width: '100%', padding: '8px 0', borderRadius: 8, border: '1px solid #e0e0dc', background: 'white', fontSize: 13, cursor: 'pointer', color: '#555' }}>
            Обновить
          </button>
        )}
      </div>
    </div>
  )
}
